import { Component, OnInit, Input, Inject } from '@angular/core';
import { ViewableRequest, ViewableCeLogistics, ViewableRequestComment } from './review-request.model';
import { asEnumerable } from 'linq-es2015';
import { ResolvedSeedRequestsService, SEED_REQUESTS } from '../../request-creation/services/resolved-seed-requests.module';
import { SeedRequest } from '../../shared/services/seed-request.service';
import { OriginatingSystem } from '../../shared/services/request.service';
import { Crop, CropService } from '../../shared/services/crop.service';
import { PollinationInstructionsComponent } from '../../request-creation/experiment-design/pollination-instructions/pollination-instructions.component';

@Component({
  selector: 'app-review-request',
  templateUrl: './review-request.component.html',
  styleUrls: ['./review-request.component.css'],
  providers: [{ provide: SEED_REQUESTS, useClass: ResolvedSeedRequestsService }]
})
export class ReviewRequestComponent implements OnInit {

  @Input() public request: ViewableRequest;
  @Input() public ceLogistics: ViewableCeLogistics;
  @Input() public requestComments: ViewableRequestComment[];
  @Input() public isWheatRequest: boolean;
  @Input() public seedRequestUrl: string;

  public showPesticidesAllowedAfterDays: boolean = false;
  public seedRequests: SeedRequest[];
  public showColdTreatmentInput: boolean = false;
  public showDonorNeeded: boolean = false;

  public PollinationInstructionsComponent = PollinationInstructionsComponent;

  public get isTnRequest(): boolean {
    return this.request.originatingSystem === OriginatingSystem.MyCE;
  }
  public get isT0Request(): boolean {
    return this.request.originatingSystem === OriginatingSystem.EvEnger;
  }

  constructor(@Inject(SEED_REQUESTS) private seedRequestsService: ResolvedSeedRequestsService, private cropService: CropService) {
    this.seedRequests = this.seedRequestsService.seedRequests;
  }

  ngOnInit() {
    this.cropService.get(this.request.cropId).subscribe({
      next: (x: Crop) => {
        this.showDonorNeeded = x.isDonorNeeded;
      }
    })
    if (this.request.weeksOfColdTreatment) {
      this.showColdTreatmentInput = true;
    }
    this.showPesticidesAllowedAfterDays = this.request.displayPesticidesAllowedAfterDays;
  }

  hasSprayEvents(): boolean {
    if (!this.request.treatments) {
      return false;
    }
    return this.request.treatments.some(treatment => treatment.sprayBoothStudyInstructions.length > 0);
  }

  public getGroupLabel(groupIndex: number): string {
    if (!this.request.pollinationInstructions || !this.request.pollinationInstructions.pollinationCategory) {
      return '';
    }

    return PollinationInstructionsComponent.getGroupLabelForCategory(
      groupIndex,
      this.request.pollinationInstructions.pollinationCategory
    );
  }

  public shouldHideConjunction(groupIndex: number): boolean {
    if (!this.request.pollinationInstructions || !this.request.pollinationInstructions.pollinationCategory) {
      return false;
    }

    return PollinationInstructionsComponent.shouldHideConjunctionByCategoryName(
      groupIndex,
      this.request.pollinationInstructions.pollinationCategory
    );
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/review-request/review-request.component.ts